import type { SxProps, Theme } from '@mui/material/styles';
import { cardSx } from './utils/styles.ts';

export const statTileSx: SxProps<Theme> = {
  ...cardSx,
  pt: 1.5,
  px: 1.5,
  pb: 2,
  display: 'flex',
  flexDirection: 'column',
  gap: 1,
  minWidth: 0,
};
